
import { i18n } from '@/assets/i18n/i18n';
const { t } = i18n.global
import { Survey, SurveyResponse, SurveyStep, SurveyStepChoice, SurveyStepRepresentationType, SurveyStepType, TIME_SPAN_MULTIPLIER } from "../models/survey.model";

export class SurveyUtils {
    survey?: Survey; responses?: SurveyResponse[];
    constructor(survey?: Survey, responses?: SurveyResponse[]) {
        this.survey = survey;
        this.responses = responses;
    };
    getStep(step_id: number): SurveyStep | undefined {
        const steps = this.survey?.steps?.filter((element) => element.id === step_id);
        return steps?.shift();
    };
    getAnswer(step_id: number, response?: SurveyResponse): SurveyAnswer | null {
        const step = this.survey?.steps?.find((step) => step.id === step_id);
        const value = response?.answers?.find((answer) => answer.step_id === step_id)?.value as string | number | PDIAnswer | undefined | null;
        // CHECK N/A
        switch (step?.type) {
            case SurveyStepType.radio:
            case SurveyStepType.value:
            case SurveyStepType.sentiment:
            case SurveyStepType.time_span:
                if (value === -1 || value === '-1') {
                    return t('feature.surveys.not_available_answer');
                }
                break;

            default:
                break;
        }
        // ANSWER
        switch (step?.type) {
            case SurveyStepType.radio:
                // CHECK IS VALUE IS NOT A NUMBER
                if (isNaN(parseInt(value as string))) {
                    return value ?? '';
                }
                return (step?.choices as SurveyStepChoice[])?.find((choice) => choice.value == value)?.text ?? '';
            case SurveyStepType.multiple:
                let result = this.getAnswerValue(step_id, response) as number[] | null;
                return ((step?.choices as SurveyStepChoice[])?.filter((choice) => result?.includes(choice.value)).map((choice) => choice.text) ?? []).join(', ');

            case SurveyStepType.sentiment:
            case SurveyStepType.value:
                return value! + this.getSuffix(step.value_representation_type);
            case SurveyStepType.time_span:
                return this.getTimeSpan(step, value as number);
            case SurveyStepType.points_of_interest:
                try {
                    return (value === null ? null : JSON.parse(value as string)) as PDIAnswer | null;
                } catch (error) {
                    return null;
                }
            default:
                return value ?? '';
        }
    };
    private getSuffix(type: SurveyStepRepresentationType | undefined): string {
        switch (type) {
            case 'percentage':
                return '%';
            case 'integer':
            default:
                return '';
        }
    }
    private getTimeSpan(step: SurveyStep, value: number): string {
        const choices = [...step.choices as SurveyStepChoice[]].reverse();
        const spans = choices.map((choice) => ({ multiplier: TIME_SPAN_MULTIPLIER[choice.value], text: choice.text }));
        let span = spans.find((span) => value % span.multiplier === 0);
        console.debug('TIME SPAN', { ...span, value });
        return `${value / span?.multiplier} ${span?.text}`;
    }

    getAnswerValue(step_id: number, response?: SurveyResponse): number | number[] | PDIAnswer | null {
        const step = this.survey?.steps?.find((step) => step.id === step_id);
        const value = response?.answers?.find((answer) => answer.step_id === step_id)?.value as string | number | PDIAnswer | undefined | null;
        // CHECK N/A
        switch (step?.type) {
            case SurveyStepType.radio:
            case SurveyStepType.value:
            case SurveyStepType.sentiment:
            case SurveyStepType.time_span:
                if (value === -1 || value === '-1') {
                    return -1;
                }
                break;

            default:
                break;
        }
        // ANSWER
        switch (step?.type) {
            case SurveyStepType.radio:
                // CHECK IS VALUE IS NOT A NUMBER
                if (isNaN(parseInt(value as string))) {
                    return null;
                }
                return value as number;
            case SurveyStepType.multiple:
                try {
                    let result = JSON.parse(value as string) as number[];
                    if (!Array.isArray(result)) {
                        return [];
                    } else {
                        return result;
                    }
                } catch (error) {
                    return [];
                }
            case SurveyStepType.sentiment:
            case SurveyStepType.value:
                return value as number;
            case SurveyStepType.time_span:
                return value as number;
            case SurveyStepType.points_of_interest:
                try {
                    return (value === null ? null : JSON.parse(value as string)) as PDIAnswer | null;
                } catch (error) {
                    return null;
                }
            default:
                return value as PDIAnswer ?? null;
        }
    };
}

export type SurveyAnswer = string | number | PDIAnswer | number[];
export type PDIAnswer = {
    [key: string]: {
        x: number,
        y: number
    }[]
}